import { render, staticRenderFns } from "./HomeModern.vue?vue&type=template&id=540f161a&scoped=true"
import script from "./HomeModern.vue?vue&type=script&lang=js"
export * from "./HomeModern.vue?vue&type=script&lang=js"
import style0 from "./HomeModern.vue?vue&type=style&index=0&id=540f161a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f161a",
  null
  
)

export default component.exports